// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgba%280,0,0,.5%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M5 14l6-6-6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2716%27 height=%2716%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27rgba%28255,255,255,.5%29%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M5 14l6-6-6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    min-height: 100vh;
    min-height: -webkit-fill-available;
  }
  
  html {
    height: -webkit-fill-available;
  }
  
  main {
    height: 100vh;
    height: -webkit-fill-available;
    max-height: 100vh;
    overflow-x: auto;
    overflow-y: hidden;
  }
  
  .dropdown-toggle { outline: 0; }
  
  .btn-toggle {
    padding: .25rem 0;
    font-weight: 600;
    color: var(--bs-emphasis-color);
    background-color: transparent;
    box-shadow: none;
  }
  .btn-toggle:hover,
  .btn-toggle:focus {
    color: rgba(var(--bs-emphasis-color-rgb), .85);
    /* background-color: var(--bs-tertiary-bg); */
  }
  
  .btn-toggle::before {
    width: 1.25em;
    line-height: 0;
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    transition: transform .35s ease;
    transform-origin: .5em 50%;
  }
  
  [data-bs-theme="dark"] .btn-toggle::before {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
  }
  
  .btn-toggle[aria-expanded="true"] {
    color: rgba(var(--bs-emphasis-color-rgb), .85);
  }
  .btn-toggle[aria-expanded="true"]::before {
    transform: rotate(90deg);
  }
  
  .btn-toggle-nav a {
    padding: .1875rem .5rem;
    margin-top: .125rem;
    margin-left: 1.25rem;
  }
  .btn-toggle-nav a:hover,
  .btn-toggle-nav a:focus {
    /* background-color: var(--bs-tertiary-bg); */
  }
  
  .scrollarea {
    overflow-y: auto;
  }
  
  .btn-fullwidth {
    width:100%;
  }

  .activeSBlink {
    font-weight: bold;
  }`, "",{"version":3,"sources":["webpack://./src/sidebar.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kCAAkC;EACpC;;EAEA;IACE,8BAA8B;EAChC;;EAEA;IACE,aAAa;IACb,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA,mBAAmB,UAAU,EAAE;;EAE/B;IACE,iBAAiB;IACjB,gBAAgB;IAChB,+BAA+B;IAC/B,6BAA6B;IAC7B,gBAAgB;EAClB;EACA;;IAEE,8CAA8C;IAC9C,6CAA6C;EAC/C;;EAEA;IACE,aAAa;IACb,cAAc;IACd,gDAAyQ;IACzQ,+BAA+B;IAC/B,0BAA0B;EAC5B;;EAEA;IACE,gDAA+Q;EACjR;;EAEA;IACE,8CAA8C;EAChD;EACA;IACE,wBAAwB;EAC1B;;EAEA;IACE,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;EACtB;EACA;;IAEE,6CAA6C;EAC/C;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,iBAAiB;EACnB","sourcesContent":["body {\n    min-height: 100vh;\n    min-height: -webkit-fill-available;\n  }\n  \n  html {\n    height: -webkit-fill-available;\n  }\n  \n  main {\n    height: 100vh;\n    height: -webkit-fill-available;\n    max-height: 100vh;\n    overflow-x: auto;\n    overflow-y: hidden;\n  }\n  \n  .dropdown-toggle { outline: 0; }\n  \n  .btn-toggle {\n    padding: .25rem 0;\n    font-weight: 600;\n    color: var(--bs-emphasis-color);\n    background-color: transparent;\n    box-shadow: none;\n  }\n  .btn-toggle:hover,\n  .btn-toggle:focus {\n    color: rgba(var(--bs-emphasis-color-rgb), .85);\n    /* background-color: var(--bs-tertiary-bg); */\n  }\n  \n  .btn-toggle::before {\n    width: 1.25em;\n    line-height: 0;\n    content: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%280,0,0,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e\");\n    transition: transform .35s ease;\n    transform-origin: .5em 50%;\n  }\n  \n  [data-bs-theme=\"dark\"] .btn-toggle::before {\n    content: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 16 16'%3e%3cpath fill='none' stroke='rgba%28255,255,255,.5%29' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M5 14l6-6-6-6'/%3e%3c/svg%3e\");\n  }\n  \n  .btn-toggle[aria-expanded=\"true\"] {\n    color: rgba(var(--bs-emphasis-color-rgb), .85);\n  }\n  .btn-toggle[aria-expanded=\"true\"]::before {\n    transform: rotate(90deg);\n  }\n  \n  .btn-toggle-nav a {\n    padding: .1875rem .5rem;\n    margin-top: .125rem;\n    margin-left: 1.25rem;\n  }\n  .btn-toggle-nav a:hover,\n  .btn-toggle-nav a:focus {\n    /* background-color: var(--bs-tertiary-bg); */\n  }\n  \n  .scrollarea {\n    overflow-y: auto;\n  }\n  \n  .btn-fullwidth {\n    width:100%;\n  }\n\n  .activeSBlink {\n    font-weight: bold;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
